export function addAutoScanLogs(logs) {
	return {
		type: 'API_POST_AUTOSCANLOG',
		payload: {
			request: {
				url: `/autoscan`,
				method: 'post',
				data: {
					logs,
				},
			},
		},
	};
}